import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { GlobalactionFielddialogComponent } from "../globalaction-fielddialog/globalaction-fielddialog.component";
import { ToastService } from "ng-uikit-pro-standard";
import { FormBuilder } from "@angular/forms";
import { AppConfig } from "src/app/config";
import { GlobalactionSectiondialogComponent } from "../globalaction-sectiondialog/globalaction-sectiondialog.component";

interface DroppedData {
  id: string;
  labelname: string;
  fieldname: string;
  fieldtype: string;
  attributes: any;
  visibility: boolean;
  standard: boolean;
  readonly: boolean;
  createddate: string;
  defaultvalue: any;
  primary: boolean;
  sequence: string;
  required: boolean;
  groupfieldsattributes: any;
}
@Component({
  selector: "app-globalaction-section",
  templateUrl: "./globalaction-section.component.html",
  styleUrls: ["./globalaction-section.component.scss"],
})
export class GlobalactionSectionComponent implements OnInit {
  @Output() translateSection: EventEmitter<string> = new EventEmitter<string>();

  translatingDialog(): void {
    this.translateSection.emit(this.sectionName);
  }
 
  @Input() section: any;
  @Input() field: any;
  @Input() groupfieldattributes: any;
  @Input() groupfields: any;
  @Input() sectionId: string;
  sectionProperties: any;
  Groupfieldattributes: any;
  sectionName: string;
  detailPage: boolean;
  editPage: boolean;
  column: number;
  readonly: boolean;
  required: boolean;
  imageSection: boolean;
  systemSection: boolean;
  draggedIndex: number | null = null;

  hidden: boolean;
  islink: boolean;
  linkfield: string;
  linkrelativeurl: string;
  object: string;
  recordtypeexist: string;

  constructor(
    public dialog: MatDialog,
    private toastrService: ToastService,
    private fb: FormBuilder,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.sectionName = this.section.sectionName;
    this.detailPage = this.section.detailPage;
    this.editPage = this.section.editPage;
    this.column = this.section.column;
    this.imageSection = this.section.imageSection;
    this.systemSection = this.section.systemSection;

    console.log(this.groupfields);
    console.log(this.section);
  }

  @Input() droppedDataFieldList: any[];

  @Output() droppedDataEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output() sectionDeleted: EventEmitter<number> = new EventEmitter<number>();

  @Output() sectionPropertiesChanged: EventEmitter<any> =
    new EventEmitter<any>();

  @Output() fieldPropertiesChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() groupFieldAttributesChanged: EventEmitter<any> =
    new EventEmitter<any>();

  @Output() fieldDeletedEvent = new EventEmitter<any>();

  hiddenIndex: number = -1;

  delete(index: any) {
    console.log("Type Deleted", index);
    const field = this.droppedDataFieldList[index];
    this.fieldDeletedEvent.emit(field);
    this.droppedDataFieldList.splice(index, 1);
  }

  sectiondialog() {
    const dialogRef = this.dialog.open(GlobalactionSectiondialogComponent, {
      data: {
        sectionProperties: {
          sectionName: this.sectionName,
          detailPage: this.detailPage,
          editPage: this.editPage,
          onnew: this.section.onnew != null ? this.section.onnew : true,
          onedit: this.section.onedit != null ? this.section.onedit : true,
          imageSection: this.imageSection,
          systemSection: this.systemSection,
          column: this.column,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The section dialog was closed");
      if (result) {
        this.updateSectionProperties(result);
        console.log("updateSectionProperties", result);
      }
    });
  }
  updateSectionProperties(properties: any): void {
    this.sectionName = properties.sectionName;
    this.detailPage = properties.detailPage;
    this.editPage = properties.editPage;
    this.section.onnew = properties.onnew;
    this.section.onedit = properties.onedit;
    this.imageSection = properties.imageSection;
    this.systemSection = properties.systemSection;
    this.column = properties.column;

    this.sectionPropertiesChanged.emit(properties);
  }

  showDialog2(fieldname: any) {
    console.log("fieldname", fieldname);

    const properties = this.groupfields[fieldname];
    console.log("properties", properties);
    const dialogRef = this.dialog.open(GlobalactionFielddialogComponent, {
      data: {
        fieldname: fieldname,
        fieldProperties: {
          readonly: properties ? properties.readonly : false,
          required: properties ? properties.required : false,
        },
      },
    });

    dialogRef.afterClosed().subscribe((results) => {
      console.log("The dialog was closed");
      console.log("fieldname", fieldname);

      if (results) {
        this.updateFieldProperties(results, fieldname);
        console.log("updateFieldProperties", results);
      }
    });
    // }
  }

  updateFieldProperties(properties: any, fieldname: any): void {
    this.readonly = properties.readonly;
    this.required = properties.required;
    const eventData = { properties, fieldname };

    this.fieldPropertiesChanged.emit(eventData);
    console.log("properties", properties);
    console.log("eventData", eventData);
  }

  updateGroupAttributes(attributes: any, fieldname: any): void {
    this.hidden = attributes.hidden;
    this.islink = attributes.islink;
    this.linkfield = attributes.linkfield;
    this.linkrelativeurl = attributes.linkrelativeurl;
    this.object = attributes.object;
    this.recordtypeexist = attributes.recordtypeexist;

    const eventData = { attributes, fieldname };

    this.groupFieldAttributesChanged.emit(eventData);
    console.log("updateGroupAttributes", attributes);
  }

  onFieldDrop(event: DragEvent) {
    event.preventDefault();
    const data = event.dataTransfer.getData("application/json");

    if (data.length > 0) {
      const field = JSON.parse(data);
      console.log("Field:", field);

      // if (field.id.startsWith("10w")) {
        if (field.hasOwnProperty("fieldtype")) {
        this.droppedDataFieldList.push(field);

        //field.required
        this.droppedDataEvent.emit({ sectionId: this.sectionId, field: field });
        // field.dropped = true;

        console.log("Dropped data:", this.droppedDataFieldList);
        console.log("data:", field);
      } else {
        console.log(" Drop not accepted.");
      }
    }
  }
  // onFieldDropchange(event: DragEvent, newIndex: number) {
  //   event.preventDefault();
  //   const droppedIndex = Number(event.dataTransfer.getData("text/plain"));

  //   if (!isNaN(droppedIndex) && droppedIndex !== newIndex) {
  //     const field = this.droppedDataFieldList[droppedIndex];
  //     this.droppedDataFieldList.splice(droppedIndex, 1);
  //     this.droppedDataFieldList.splice(newIndex, 0, field);

  //     // Update the index attribute of each item
  //     this.droppedDataFieldList.forEach((item, index) => {
  //       item.index = index;
  //     });

  //     console.log("Dropped data reordered:", this.droppedDataFieldList);
  //   }
  // }

  onFieldDropchange(event: DragEvent, newIndex: number) {
    event.preventDefault();

    console.log("Current index", this.draggedIndex);
    console.log("Dropped index", newIndex);
    if (this.draggedIndex !== null && this.draggedIndex !== newIndex) {
      // Swap the positions of the dragged item and the dropped item
      const tempField = this.droppedDataFieldList[this.draggedIndex];
      this.droppedDataFieldList[this.draggedIndex] =
        this.droppedDataFieldList[newIndex];
      this.droppedDataFieldList[newIndex] = tempField;

      this.droppedDataFieldList.forEach((item, index) => {
        item.index = index;
      });

      console.log("Dropped data reordered:", this.droppedDataFieldList);
    }

    //Reset index
    this.draggedIndex = null;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;

    console.log(index);
  }




  getColumnSize(index: number): number {
    return index % 2 === 0 ? 6 : 12;
  }

  deleteSection(index: number): void {
    this.sectionDeleted.emit(index);
  }
}
